import React, { Suspense, useEffect, useState } from "react";
import { Canvas } from "@react-three/fiber";
import { OrbitControls, Preload, useGLTF } from "@react-three/drei";
import CanvasLoader from "./Loader";

const Computers = ({ isMobile }) => {
     const computer = useGLTF("./drone/scene.gltf");
     return (
          <mesh>
               <hemisphereLight intensity={10} groundColor='black' />
               <spotLight position={[0, 30, 10]} angle={0.12} penumbra={1} intensity={1} castShadow shadow-mapSize={1024} />
               <pointLight intensity={5} />
               <primitive object={computer.scene} scale={isMobile ? 50 : 60} position={isMobile ? [0, 0.5, 0] : [0, 0.5, 0.2]} rotation={[0, -1.4, 0]} />
          </mesh>
     );
};

const ComputersCanvas = () => {
     const [isMobile, setIsMobile] = useState(false);
     useEffect(() => {
          const mediaQuery = window.matchMedia("(max-width: 500px)");
          setIsMobile(mediaQuery.matches);
          const handleMediaQueryChange = (event) => {
               setIsMobile(event.matches);
          };
          mediaQuery.addEventListener("change", handleMediaQueryChange);
          return () => {
               mediaQuery.removeEventListener("change", handleMediaQueryChange);
          };
     }, []);
     return (
          <Canvas frameloop='demand' shadows dpr={[1, 2]} camera={{ position: [20, 3, 5], fov: 25 }} gl={{ preserveDrawingBuffer: true }}>
               <Suspense fallback={<CanvasLoader />}>
                    <OrbitControls enableZoom={false} />
                    <Computers isMobile={isMobile} />
               </Suspense>
               <Preload all />
          </Canvas>
     );
};

export default ComputersCanvas;